import React, { useState } from 'react';
import { useDispatch } from 'src/state/redux';

import { DNABox, DNACheckbox, DNAModal, DNAText, luxColors } from '@alucio/lux-ui';
import { DNAModalActions } from 'src/state/redux/slice/DNAModal/DNAModal';
import { useAppSettings } from 'src/state/context/AppSettings';

interface Props {
  onConfirmAction?: (clearData: boolean) => void;
  onCancelAction?: () => void;
}

const DNACommonConfirmationSignOut = (props: Props) => {
  const { isPWAStandalone } = useAppSettings()
  const { onConfirmAction, onCancelAction } = props;
  const dispatch = useDispatch();
  const [clearData, setClearData] = useState(false)

  function closeModal(): void {
    dispatch(DNAModalActions.closeModal());
    onCancelAction?.();
  }

  function onAction(): void {
    onConfirmAction?.(clearData);
  }

  const headerText = isPWAStandalone ? 'Log out from Beacon app' : 'Log out from all tabs and the Beacon app';

  return (
    <DNAModal>
      <DNAModal.Header onClose={closeModal}>
        {headerText}
      </DNAModal.Header>
      <DNAModal.Body>
        <DNABox style={{ padding: 8, minWidth: 384 }} appearance="col">
          { /* Keep data */}
          <DNABox style={{ marginTop: 16 }}>
            <DNACheckbox checked={clearData} onChange={setClearData} />
            <DNAText style={{ color: luxColors.flat.primary, marginLeft: 8 }}>
              Clear all stored data
            </DNAText>
          </DNABox>
        </DNABox>
      </DNAModal.Body>
      <DNAModal.Confirmation
        onCancel={closeModal}
        onAction={props.onConfirmAction ? onAction : undefined}
        actionLabel="Log out"
        actionStatus="primary"
      />
    </DNAModal>
  )
};

export default DNACommonConfirmationSignOut;
